import React, { Component } from 'react';
import { FormGroup, Col } from 'reactstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Toggle from "react-toggle";
import "react-toggle/style.css";

const startDateLabel = 'Start Date';
const endDateLabel = 'End Date';
const latestDataAvailable = 'latest data available';

class DateFilter extends Component {
  constructor() {
    super();
    this.state = {
      isLatestDateFilterSelected : false
    }
  }
  componentDidMount() {
    const datePickerEffectiveDate = document.getElementsByClassName('react-datepicker__input-container')[0];
    datePickerEffectiveDate.childNodes[0].setAttribute('readOnly', true);
    const datePickerEndDate = document.getElementsByClassName('react-datepicker__input-container')[1];
    datePickerEndDate.childNodes[0].setAttribute('readOnly', true);
  }

  handleToggleChange = (event) => {
    const { checked } = event.target;
    this.setState({
      isLatestDateFilterSelected : checked
    }, () => {
        this.props.handleEndDateChange(moment().toISOString())
    });
  }

  handleStartDatePicker = (id) => { document.getElementById(id).click() }
  handleEndDatePicker = (id) => { document.getElementById(id).click() }

  render() {

    const { handleStartDateChange, handleEndDateChange, searchObject: { startDate, endDate } } = this.props;
    const { isLatestDateFilterSelected } = this.state;

    return (
      <div>
        <FormGroup className="mt25" row>
          <Col sm={2} className="text-right">
            <div className="text-right chartLabel">{startDateLabel}</div>
          </Col>
          <Col sm={3} md={3} className="align-self-center">
            <div className="inner-addon right-addon">
              <span className="tool-start-date flaticon-calendar" onClick={() => this.handleStartDatePicker('startDatePicker')} />
              <DatePicker
                id="startDatePicker"
                ref={r => { this.componentStart = r }}
                className="input-custom-date form-control"
                selectsStart
                selected={
                  startDate
                    ? moment(startDate).local()
                    : null
                }
                onChange={(date) => handleStartDateChange(moment(date).toISOString())}
                endDate={endDate ? moment(endDate).local() : null}
                startDate={startDate ? moment(startDate).local() : null}
                // minDate={moment()}
                maxDate={endDate ? moment(endDate).local() : null}
                showYearDropdown
              />
            </div>
          </Col>
        </FormGroup>
        <FormGroup className="mt25" row>
          <Col sm={2} className="text-right">
            <div className="text-right chartLabel">{endDateLabel}</div>
          </Col>
          <Col sm={3} className="align-self-center">
            <div className="inner-addon right-addon">
              <span className="tool-end-date"><span className="flaticon-calendar" onClick={() => this.handleEndDatePicker('endDatePicker')} /></span>
              <DatePicker
                id="endDatePicker"
                ref={r => { this.componentStart = r }}
                className="input-custom-date form-control"
                selectsEnd
                selected={endDate && !isLatestDateFilterSelected ? moment(endDate).local() : null}
                onChange={(date) => handleEndDateChange(moment(date).toISOString())}
                startDate={startDate ? moment(startDate).local() : null}
                endDate={endDate ? moment(endDate).local() : null}
                minDate={startDate ? moment(startDate).local() : moment()}
                maxDate={moment()}
                disabled={isLatestDateFilterSelected}
                showYearDropdown
              />
            </div>
          </Col>
          <Col className="d-flex pl0">
            <div className="d-flex align-items-center">
              <span className="or-latest-data">or</span>
              <span className="ml10">
                <Toggle icons={false} onChange={this.handleToggleChange}  />
              </span>
              <span className="ml10 latest-data-available">{latestDataAvailable}</span>
              <span id="latest-data-available-popover" className="ml10 d-none"></span>
            </div>
          </Col>
        </FormGroup>
      </div>
    )
  }
}

export default DateFilter;